/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ConfirmProductChartMatchMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type ConfirmProductChartMatchMutation = { __typename: 'Mutation', confirmProductChartMatch: number | null };


export const ConfirmProductChartMatchDocument = gql`
    mutation confirmProductChartMatch($id: String!) {
  confirmProductChartMatch(id: $id)
}
    `;
export type ConfirmProductChartMatchMutationFn = Apollo.MutationFunction<ConfirmProductChartMatchMutation, ConfirmProductChartMatchMutationVariables>;

/**
 * __useConfirmProductChartMatchMutation__
 *
 * To run a mutation, you first call `useConfirmProductChartMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmProductChartMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmProductChartMatchMutation, { data, loading, error }] = useConfirmProductChartMatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmProductChartMatchMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmProductChartMatchMutation, ConfirmProductChartMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmProductChartMatchMutation, ConfirmProductChartMatchMutationVariables>(ConfirmProductChartMatchDocument, options);
      }
export type ConfirmProductChartMatchMutationHookResult = ReturnType<typeof useConfirmProductChartMatchMutation>;
export type ConfirmProductChartMatchMutationOptions = Apollo.BaseMutationOptions<ConfirmProductChartMatchMutation, ConfirmProductChartMatchMutationVariables>;